import { useEffect, useState } from 'react'
import { formatDateForApi, DateFilters } from 'pixel-base'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { getDashboardProducts } from 'utils/api-routes-analytics'

interface TopProduct {
  base_product_id: number
  product_name: string
  total_items_sold: number
  total_revenue: number
  collection_names: string[]
  variations: Array<{
    variation_id: number
    sku: string
    product_name: string
    items_sold: number
    revenue: number
    image: string | null
  }>
}

interface DetailProductsData {
  products: TopProduct[]
  loading: boolean
  error: string | null
}

export const useDetailProductsData = (
  filters: DateFilters,
  enabled: boolean = false,
): DetailProductsData => {
  const [data, setData] = useState<DetailProductsData>({
    products: [],
    loading: false,
    error: null,
  })

  useEffect(() => {
    if (!enabled) {
      setData({ products: [], loading: false, error: null })
      return
    }

    setData((prev) => ({ ...prev, loading: true, error: null }))

    const payload = {
      start_date: formatDateForApi(filters.start_date),
      end_date: formatDateForApi(filters.end_date),
      limit: 100,
    }

    const subscription = getDashboardProducts(payload)
      .pipe(
        map((response: any) => response.response),
        catchError((error) => {
          console.error('Error fetching detail products data:', error)
          return of({ products: [], meta: {} })
        }),
      )
      .subscribe((response: any) => {
        setData({
          products: response.data || [],
          loading: false,
          error: null,
        })
      })

    return () => subscription.unsubscribe()
  }, [filters.start_date, filters.end_date, enabled])

  return data
}
